define(
    'modals/secured/explorer/details/tabs/actions/DocumentActionErrorModal',[
        "plugins/dialog",
        "i19n!i19n/strings"
    ],
    function (dialog, i19n) {

        function Modal() {
            var self = this;

            self.i19n = i19n;
            self.messages = ko.observableArray();
            self.documentResults = ko.observableArray();
        }

        Modal.prototype = {
            activate: function(result) {
                var self = this;

                self.messages(result.messages);
                self.documentResults(result.documentResults);
            },
            
            //TODO: 15-Nov-2013 - consider writing a re-usable custom durandal.dialog context to handle sizing according to our needs.
            compositionComplete: function (child, parent, context) {

                // resize the modal-body portion to scroll vertically if there are a lot of messages.

                var $modal = $(child);
                var $body = $modal.find(".modal-body");

                var bodyOuterHeight = $body.outerHeight(true);
                var bodyHeight = $body.height();

                var modalOuterHeight = $modal.outerHeight(true);
                var windowHeight = $(window).height();
                
                if (modalOuterHeight > windowHeight) {
                    var leftOvers = modalOuterHeight - bodyOuterHeight;
                    var newBodyHeight = windowHeight - leftOvers - (bodyOuterHeight - bodyHeight);

                    $body.height(newBodyHeight);
                    $body.css({ 'overflow-y': 'scroll'});
                }

            },
            ok: function() {
                var self = this;
                dialog.close(self, { ok: true });
            }
        };

        return Modal;
    }
);
